// extracted by mini-css-extract-plugin
export default {"bulkMessageWrapper":"WumVEwsPxuI9aSAyuQI1","rtl":"q3gH_W2V1GQvD0_dxhMw"};